import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import {
  getAirlines,
  deleteAirline,
  changeAirlineStatus,
} from "../api/airlineApi";
import { confirmDialog } from "../utils/alert";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";

export default function AirlinesList() {
  const [airlines, setAirlines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const loadAirlines = async () => {
    setLoading(true);
    try {
      const res = await getAirlines({ page, per_page: perPage });
      setAirlines(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAirlines();
  }, [page, perPage]);

  const handleDelete = async (id) => {
    const confirmed = await confirmDialog({ text: "Delete this airline?" });
    if (!confirmed) return;
    await deleteAirline(id);
    loadAirlines();
  };

  const handleToggleActive = async (airline) => {
    await changeAirlineStatus(airline.id, !airline.is_active);
    loadAirlines();
  };

  return (
    <AdminLayout title="Airlines">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title mb-0">Airline List</h5>
            <button
              className="btn skedq-accent-btn"
              onClick={() => navigate("/airlines/new")}
            >
              Add New Airline
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Name</th>
                  <th>IATA</th>
                  <th>Country</th>
                  <th>Alliance</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && airlines.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      No airlines found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  airlines.map((a, index) => (
                    <tr key={a.id}>
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td>{a.name}</td>
                      <td>{a.iata_code}</td>
                      <td>{a.country}</td>
                      <td>{a.alliance}</td>
                      <td>
                        <span
                          className={
                            "badge " +
                            (a.is_active ? "bg-success" : "bg-secondary")
                          }
                        >
                          {a.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => navigate(`/airlines/edit/${a.id}`)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => handleToggleActive(a)}
                          >
                            {a.is_active ? "Deactivate" : "Activate"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(a.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
